var mainNav = document.getElementById("main-header");

window.onscroll = function() {
  "use strict";
  if (document.body.scrollTop >= 40 || document.documentElement.scrollTop >= 40) {
    mainNav.classList.add("nav-scroll");
  } else {
    mainNav.classList.remove("nav-scroll");
  }
};


// update the sort_by parameter of the current url when the sort-by select is changed
document.getElementById("SortBy").addEventListener('change', function (e) {
    var params = new URLSearchParams(window.location.search)
    var newparams = []
    for (let param of params) {
        var k = param[0]
        var v = param[1]
        if (k !== 'sort_by') {
            newparams.push(encodeURIComponent(k) + '=' + encodeURIComponent(v))
        }
    }

    newparams.unshift('sort_by=' + e.currentTarget.value)
    window.location.search = newparams.join('&')
})

// const dropdownButton = document.querySelector('.collection--body--right-top-right-button');
// const dropdownMenu = document.querySelector('.n-r-2-dropdown');
// console.log("dropdownMenu", dropdownMenu)
// console.log("dropdownButton", dropdownButton)
// if (dropdownButton) {
//   dropdownButton.addEventListener('click', function() {
//     dropdownMenu.classList.toggle('show');
//   });
// }

// window.addEventListener('click', function(event) {
//   if (!event.target.matches('.collection--body--right-top-right-button') && !event.target.matches('.collection--body--right-top-right-button *')) {
//     if (dropdownMenu.classList.contains('show')) {
//       dropdownMenu.classList.remove('show');
//     }
//   }
// });

// const dropdownButton1 = document.querySelector('.collection--body--right-top-right-button-1');
// const dropdownMenu1 = document.querySelector('.n-r-2-dropdown-1');
// console.log("dropdownMenu1", dropdownMenu1)
// console.log("dropdownButton1", dropdownButton1)
// if (dropdownButton1) {
//   dropdownButton1.addEventListener('click', function() {
//     dropdownMenu1.classList.toggle('show');
//   });
// }

// window.addEventListener('click', function(event) {
//   if (!event.target.matches('.collection--body--right-top-right-button-1') && !event.target.matches('.collection--body--right-top-right-button-1 *')) {
//     if (dropdownMenu1.classList.contains('show')) {
//       dropdownMenu1.classList.remove('show');
//     }
//   }
// });

// var elementBlogMenuTrigger = document.getElementById('blog-nav-trigger');
// var elementBlogMenuNav = document.getElementById('blog-top-nav-outer');
// elementBlogMenuTrigger.addEventListener('click', (e) => {
//   console.log('[HERE]');
//   if (elementBlogMenuNav.classList.contains('opened')) {
//     elementBlogMenuTrigger.classList.remove('opened');
//     elementBlogMenuNav.classList.remove('opened');
//   } else {
//     elementBlogMenuTrigger.classList.add('opened');
//     elementBlogMenuNav.classList.add('opened');
//   }
// })